import { IconButton, css, styled } from "@mui/material";

const ToggleIconButton = styled(IconButton, {
  name: 'ToggleIconButton',
  slot: 'root',
  shouldForwardProp: prop => !['active'].includes(prop)
})`
  ${({ theme, active }) => active && css`
    &, &:hover {
      background-color: ${theme.palette.primary.dark};
      color: ${theme.palette.common.white};
    }
  `}
`;

export default ToggleIconButton;